import React from "react";
import { formatMoney } from "@/utils/billingFormat";

const BillTotalsCard = ({ bill, children, className = "" }) => {
  const currencyCode = bill?.currencyCode || "NPR";
  const dueAmount = Number(bill?.dueAmount ?? 0);
  const hasDue = dueAmount > 0;

  const rows = [
    ["Subtotal", bill?.subTotal],
    ["Discount", bill?.discountTotal],
    ["Tax", bill?.taxTotal],
    ["Service charge", bill?.serviceChargeTotal],
  ];

  return (
    <div className={`flex flex-col justify-between rounded-2xl border bg-background p-4 ${className}`}>
      <div>
        <p className="mb-4 font-semibold">Totals</p>
        <div className="space-y-2.5">
          {rows.map(([label, value]) => (
            <div key={label} className="flex items-center justify-between gap-3 text-sm">
              <span className="text-muted-foreground">{label}</span>
              <span className="font-medium tabular-nums">{formatMoney(value, currencyCode)}</span>
            </div>
          ))}

          {/* Grand total */}
          <div className="flex items-center justify-between gap-3 border-t pt-3 text-base font-bold">
            <span>Grand total</span>
            <span className="tabular-nums">{formatMoney(bill?.grandTotal, currencyCode)}</span>
          </div>

          {/* Paid */}
          <div className="flex items-center justify-between gap-3 text-sm">
            <span className="text-muted-foreground">Paid amount</span>
            <span className="font-medium tabular-nums text-emerald-600">
              {formatMoney(bill?.paidAmount, currencyCode)}
            </span>
          </div>

          {/* Due amount — hero row with accent strip */}
          <div
            className={`-mx-4 flex items-center justify-between gap-3 border-t px-4 pt-3 text-base font-bold ${
              hasDue ? "text-red-600" : "text-emerald-600"
            }`}
          >
            <span>{hasDue ? "Due amount" : "Fully paid"}</span>
            <span className="tabular-nums">{formatMoney(bill?.dueAmount, currencyCode)}</span>
          </div>
        </div>
      </div>

      {children && <div className="mt-4 pt-1">{children}</div>}
    </div>
  );
};

export default BillTotalsCard;
